<template>
    <div>
        <Header />
        <div>
            <div class="title">
                <span class="navTitle">
                    <span class="exhibitTitle"><span @click="navigateToExhibits" style="font-style: default;">{{ exhibitName }} <span style="font-style: italic;">: Retourner aux expositions > </span></span> 
                       <span style="font-style: italic;"> Créer la page d'accueil</span> </span>
                </span>
                <div class="info-icon">
                    <q-btn flat round dense icon="info">
                        <q-popup-proxy ref="popup">
                            <q-card>
                                <q-card-section>
                                    Paramétrer votre page d'accueil et choisissez une mise en page 
                                </q-card-section>
                            </q-card>
                        </q-popup-proxy>
                    </q-btn>
                </div>
            </div>
            <div class="navButtons">
                <q-btn color="pink-10" style="margin-left: 7%" @click="navigateBack">Retour</q-btn>
                <div>
                    <q-btn label="Prévisualiser l'exposition en ligne" color="blue-grey-4" @click="openNewTab" />
                </div>
                <q-btn style="margin-right: 5%" label="Page suivante" color="deep-purple-11"
                    @click="navigateToCreation"><q-tooltip>
                        Le passage à la page suivante valide l'ensemble de vos modifications
                    </q-tooltip></q-btn>
            </div>
        </div>
        <hr style="margin-bottom: 15px" />
        <q-banner v-if="error" class="app-banner app-banner--error" dense rounded>
            Erreur d'enregistrement
        </q-banner>
        <ExpositionHomePageSetup ref="expositionPageSetup" :key="exhibitId"/>
        <BetweenPageLoader v-if='betweenPage' />
    </div>
</template>
<script>
import { urlExposition } from '@/utils/urlExposition';
import Header from '../components/Header.vue';
import ExpositionHomePageSetup from '../components/ExpositionHomePageSetup.vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router'
import axios from 'axios';
import { ref, onMounted } from 'vue';
import BetweenPageLoader from '../components/BetweenPageLoader.vue';
export default {
    components: {
        Header,
        ExpositionHomePageSetup,
        BetweenPageLoader
    },
    setup() {
        const store = useStore();
        const route = useRoute();
        const router = useRouter();
        let exhibitId = ref(route.params.id);
        let exhibitName = ref('');
        let exhibitTemplate = ref('');
        let exhibitUrl = ref('');
        const expositionPageSetup = ref(null);
        var betweenPage = ref(false);
        var error = ref(false);
        let showInfo = ref(false);
        let expositionPageSetupKey = ref(0);

        // Mettre à jour le store IMMEDIATEMENT avec l'ID de la route
        // pour que les composants enfants aient le bon ID dès leur montage
        store.commit('RESET_EXHIBIT_DATA');
        store.commit('SET_EXHIBITID', exhibitId.value);

        const start = async () => {
            await getExhibitInfos();
        }

        const openNewTab = () => {
            window.open(exhibitUrl.value, '_blank');
        }
        const getExhibitInfos = async () => {
            try {
                let url = `${process.env.VUE_APP_BASEURL}/exhibit/${exhibitId.value}`;
                let response = await axios.get(url);
                exhibitName.value = response.data.exhibit_name;
                store.commit('SET_EXHIBITNAME', exhibitName.value);
                exhibitTemplate.value = response.data.template_name ;
                exhibitUrl.value = urlExposition(exhibitTemplate.value, exhibitId.value);
                store.commit('SET_EXHIBITURL', exhibitUrl.value);
            } catch (error) {
                console.log(error);
            }
        }

        const navigateBack = () => {
            router.go(-1);
        }

        const navigateToExhibits = () => {
            router.push("/admin")
        }

        const saveAllPage = async () => {
            try {
                if (expositionPageSetup.value) {
                    await expositionPageSetup.value.sendHomePageImage();
                }
            } catch (error) {
                error.value = true;
                setTimeout(() => {
                    error.value = false;
                }, 1500);
                throw error;
            }
            await expositionPageSetup.value.saveRights();


        }

        const navigateToCreation = async () => {
            try {
                await saveAllPage();
                betweenPage.value = true;
                console.log("exhibitTemplate", exhibitTemplate.value)
                setTimeout(() => {
                    betweenPage.value = false;
                    if (!exhibitTemplate.value){
                        router.push('/creation')
                    }
                    else if (exhibitTemplate.value === 'template_6') {
                        router.push('/point');
                    } else {
                        router.push('/templateManagement');
                    }
                }, 3000);
            } catch (error) {
                error.value = true;
                setTimeout(() => {
                    error.value = false;
                    betweenPage.value = false;
                }, 1500);
            }
        }


        onMounted(() => {
            start();
        })
        return {
            exhibitId,
            exhibitTemplate,
            exhibitName,
            exhibitUrl,
            expositionPageSetup,
            betweenPage,
            error,
            showInfo,
            expositionPageSetupKey,
            getExhibitInfos,
            navigateBack,
            navigateToCreation,
            openNewTab,
            navigateToExhibits
        }
    }
}
</script>
<style scoped>
.navButtons {
    display: flex;
    justify-content: space-between;
}

.title {
  display: flex;
  align-items: center;
  font-size: 1.2 rem;
  margin-left: 1%;
}
</style>